var map = {
	"./application-form.png": "409c",
	"./bill-check.png": "9454",
	"./energy-price-alerts-md.png": "3982",
	"./energy-trading-md.png": "4645",
	"./ev-charging-building.png": "45d6",
	"./ev-charging-md.png": "5891",
	"./graph2.jpg": "ce2c",
	"./logo.svg": "9b19",
	"./magnify-graph.png": "e3c2",
	"./mic-brokerage-md.png": "4a99",
	"./mic-brokerage.png": "7562",
	"./moblie-phone-md.png": "d6ff",
	"./nie-applications-md.png": "e54a",
	"./nie-connection-confi-md.png": "2935",
	"./software-dev.jpg": "43f7",
	"./trading-small.jpg": "4dbf",
	"./wind-solar-graph-lg.png": "b0b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";